import {ImageTreatmentLogo as TreatmentLogo} from './ImageTreatmentLogo';
import {ImageCaraWow as CaraWow} from './ImageCaraWow';
import {ImageCheckboxPressed as CheckboxPressed} from './ImageCheckBoxPressed';
export {TreatmentLogo, CheckboxPressed, CaraWow};
